import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../componentLibrary/Button";
import LearnIcon from "../assets/icons/learn.svg";

interface ToolboxBottomNavigationProps {
  fromUrl: string;
  topicId: string;
}

const ToolboxBottomNavigation: React.FC<ToolboxBottomNavigationProps> = ({
  fromUrl,
  topicId,
}) => {
  const navigate = useNavigate();

  const isFromLesson = fromUrl.includes("/sections/");
  const isFromTopicOnly = fromUrl.includes("/topics/") && !isFromLesson;

  const handleReturn = () => {
    if (!isFromLesson && !isFromTopicOnly) {
      navigate(`/topics/${topicId}`);
    } else {
      navigate(fromUrl);
    }
  };

  const buttonText = isFromLesson ? "Return to Section" : "Return to Topic";

  return (
    <div className="w-full bg-white border-t border-gray-200 shadow-md">
      <div className="w-full max-w-none px-4 pt-4 pb-8 mb-6">
        <div className="flex items-center justify-center max-w-md mx-auto">
          <Button
            variant="primary"
            onClick={handleReturn}
            className="!h-10 flex items-center gap-2 px-6"
            size="md"
            roundedFull
          >
            <img src={LearnIcon} alt="" className="w-8 h-8" />
            {buttonText}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ToolboxBottomNavigation;
